
export class Address {
    
    public name             : string = '';

    public addressLine1     : string = '';
    
    public addressLine2     : string = '';
    
    public city             : string = '';
    
    public stateProvince    : string = '';
    
    public postalCode       : string = '';
    
    public country          : string = '';
    
    public isNew            : boolean = false;
    
    public latitude         : number = 0;
    
    public longitude        : number = 0;
    
    public timeZoneId       : string = '';

    public isJobSite        : boolean = false;

    public isDefault        : boolean = false;
}
